import BaseServices from "./BaseServices";

const CusStockphotoServices = {
    CreateManyStockPhoto: async (model) => {
        return BaseServices.Post(`/api/CUSStockPhoto/create-many-stock-photo`, model);
    },
    // Customize frame save uses the CUSStockPhoto API endpoint that writes frame asset metadata.
    CreateUpdateCustomizeFrame: async (model) => {
        return BaseServices.Post(`/api/CUSStockPhoto/create-update-customize-frame`, model);
    },
    // Customize frame tab uses this API to read frame assets from CUSStockPhotoController.
    GetCustomizeFrameByPage: async (model) => {
        return BaseServices.Post(`/api/CUSStockPhoto/get-customize-frame-by-page`, model);
    },
    // Frame action calls the route endpoint that marks one frame asset inactive.
    SetUnactiveFrame: async (id) => {
        return BaseServices.Get(`/api/CUSStockPhoto/set-unactive-frame/${id}`);
    },
};

export default CusStockphotoServices;
